/**************************************************
 * Nombre:       Formulario_Comision_Ver
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {Flag, InventoryOutlined, Money, MoveUpOutlined} from "@mui/icons-material";
import IngresoDinero from "../../Modulo_formularios/Componentes/IngresoDinero";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {useEffect, useState} from "react";

const Formulario_Comision_Ver = ({...props}) => {
    const [esDistribuidor, setEDistribuidor] = useState(false);

    useEffect(() => {

        let es = props.props.getValues('rango');

        let dox = props.props.getValues();
        console.log(dox)

        if (es === 'Distribuidor') {
            setEDistribuidor(true);
        } else {
            setEDistribuidor(false);
        }

    }, [props.props.watch('distribuidor')]);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoSelect Icono={InventoryOutlined} nombre={'Estado de venta'} dato={'estado'} {...props}
                                   requerido={'El Nombre es requerido'} opciones={['Simulacion', 'Venta Real']}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={InventoryOutlined} nombre={'Nombre de producto'} dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'} editable={false}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoDinero Icono={Money} nombre={'Precio del producto USD'} dato={'valor'} {...props}
                                   editable={false}
                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoTexto Icono={Flag} nombre={'Zona de entrega'} dato={'zona'} {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={MoveUpOutlined} nombre={'Tipo de Simulacion'} dato={'tipo'} {...props}
                                  requerido={'El estado es requerido'} editable={false}
                    />
                </Grid>




            </Grid>

        </form>

    )

}
export default Formulario_Comision_Ver

const zonas = [
    {
        nombre: 'Colombia',
        valor: 15
    },
    {
        nombre: 'Ecuador',
        valor: 15
    },
    {
        nombre: 'Cuba',
        valor: 10
    }
]